<button mat-icon-button class="close-button" [mat-dialog-close]="true">
    <mat-icon class="close-icon" color="warn">close</mat-icon>
</button>

<div mat-dialog-title class="flex-container">
    <h2>¿Qué es una PyME nueva?</h2>
</div>
<mat-dialog-content class="mat-typography">
    <h3>Se consideran Start Ups o PyMES nuevas a aquellas personas o empresas que se están iniciando en la actividad objeto del financiamiento.</h3>
    <h3>Recordá que tanto monotributistas como responsables inscriptos son considerados PyMES</h3>
</mat-dialog-content>
<!--<mat-dialog-actions align="end">-->
<!--    <button mat-button mat-dialog-close>Ok</button>-->
<!--</mat-dialog-actions>-->
